module.exports = __webpack_public_path__ + "img/icon9.56993de2.svg";